export interface StatusInterface {
   code: string;
   status: string;
   date: string;
   event: string;
   reason: string;
}

export class Status implements StatusInterface {
   code: string;
   status: string;
   date: string;
   event: string;
   reason: string;

   constructor( s?: Status ) {
      this.code = s.code;
      this.status = s.status;
      this.date = s.date;
      this.event = s.event;
      this.reason = s.reason;
   }

   public toString = (): string => {
      return this.status + '◬' + this.date;
   }
}
